import api from '@/api/task';
import stageApi from '@/api/stage';
import store from '@/store';
import popup from '@/model/popup';
import userCustomSettings from '@/model/userCustomSettings';

const commit = (items) => { store.commit('taskList/set', items); };

export default {
  fetch(filter) {
    api.fetchList(filter, true).then((r) => { commit(r.items); });
  },
  resort(items, stageId, projectId) {
    const taskSort = { ...store.state.auth.user.customSettings?.taskSort } ?? {};
    taskSort[projectId] ??= {};
    taskSort[projectId][stageId] = items.map(t => t.id);

    const taskWithChangedStage = items.find(i => i.stage.id !== stageId);

    if (taskWithChangedStage) {
      const prevStageId = taskWithChangedStage.stage.id;

      const prevStageSort = taskSort[projectId][prevStageId] ?? [];
      taskSort[projectId][prevStageId] = prevStageSort.filter(id => id !== taskWithChangedStage.id);

      this.update({
        id: taskWithChangedStage.id,
        field: 'stage',
        value: {
          id: stageId,
          '@id': stageApi.getIri(stageId),
        },
      });
    }

    userCustomSettings.set({ taskSort });
  },
  update({ id, field, value }) {
    const tasks = [...store.state.taskList.items];
    const i = tasks.findIndex(t => t.id === id);
    const task = tasks[i];
    const prevValue = task[field];

    tasks.splice(i, 1, { ...task, [field]: value });
    commit(tasks);

    api.update(id, { [field]: value?.['@id'] ?? value })
      .catch(() => {
        popup.addAlert('Во время обновления произошла ошибка');

        tasks.splice(i, 1, { ...task, [field]: prevValue });
        commit(tasks);
      });
  },
  async remove(task) {
    const tasks = [...store.state.taskList.items];
    const i = tasks.findIndex(t => t.id === task.id);

    if (!await popup.addConfirm(`Вы действительно хотите удалить задачу [${task.name}]?`)) return;

    api.delete(task.id, true)
      .then(() => {
        tasks.splice(i, 1);
        commit(tasks);
      })
      .catch(() => {
        popup.addAlert('Во время обновления произошла ошибка');
      });
  },
};
